module.exports = __webpack_public_path__ + "img/handraw_sécurité- footer copie.9bbefbbe.svg";